import { DomainValidationError } from "./identifiers.js";
export function minorUnits(value) {
    if (!Number.isSafeInteger(value) || value < 0) {
        throw new DomainValidationError("minorUnits", "must be a safe non-negative integer");
    }
    return value;
}
// Shape only: assignment against the ISO 4217 list (and its minor-unit exponent) is a later,
// domain-level allowlist.
export function currencyCode(value) {
    if (typeof value !== "string" || !/^[A-Z]{3}$/.test(value)) {
        throw new DomainValidationError("currencyCode", "must be three uppercase letters");
    }
    return value;
}
/**
 * The currencies Lafayette prices and charges in (owner decision 5), with their minor-unit
 * exponents (the number of decimal places of the minor unit: 2 means hundredths). Frozen: the
 * catalog's database CHECKs are generated from `supportedCurrencyCodes`. `currencyCode` above stays
 * shape-only for compatibility; anything that stores a price uses `supportedCurrency`.
 */
export const supportedCurrencies = Object.freeze({
    INR: 2,
    USD: 2,
    EUR: 2,
    GBP: 2,
    SGD: 2,
    AED: 2,
});
export const supportedCurrencyCodes = Object.freeze(Object.keys(supportedCurrencies));
/** A currency on the allow-list. The message names the field and the rule, never the value. */
export function supportedCurrency(value) {
    if (typeof value !== "string" || !Object.hasOwn(supportedCurrencies, value)) {
        throw new DomainValidationError("currency", "is not supported");
    }
    return value;
}
export function money(amountMinor, currency) {
    return { amountMinor: minorUnits(amountMinor), currency: currencyCode(currency) };
}
